import React, { forwardRef, useRef, useImperativeHandle,useEffect } from "react";
import NanoPlayer from "./Nano";
import TencentPlayer from "./Tencent";
import {
  StreamPlayerWrap
} from "./styles";

const StreamPlayer = forwardRef(({ stream, altStream = false, NANO_PLAYER_URL, TENCENT_PLAYER_URL }, ref) => {
  const nanoRef = useRef(null);
  const tencentRef = useRef(null);

  const isNano = stream.rtmpUrl && stream.rtmpUrl.length > 0;
  const isTencent = !isNano && stream.webRtcUrl && stream.webRtcUrl.length > 0;
  useEffect(() => {
    if (isNano && nanoRef.current) {
      nanoRef.current.mute();
      nanoRef.current.play();
    } else if (isTencent && tencentRef.current) {
      tencentRef.current.mute();
      tencentRef.current.play();
    }
  }, [isNano, isTencent]);

  useImperativeHandle(ref, () => {
    const safeCall = (playerRef, methodName, ...args) => {
      if (playerRef && playerRef.current && typeof playerRef.current[methodName] === "function") {
        playerRef.current[methodName](...args);
      }
    };

    return {
      play: () => {
        if (isNano) safeCall(nanoRef, "play");
        else if (isTencent) safeCall(tencentRef, "play");
      },
      pause: () => {
        if (isNano) safeCall(nanoRef, "pause");
        else if (isTencent) safeCall(tencentRef, "pause");
      },
      stop: () => {
        if (isNano) safeCall(nanoRef, "stop");
        else if (isTencent) safeCall(tencentRef, "stop");
      },
      changeQuality: (id) => {
        if (isNano) safeCall(nanoRef, "changeQuality", id);
        else if (isTencent) safeCall(tencentRef, "changeQuality", id);
      },
      mute: () => {
        if (isNano) safeCall(nanoRef, "mute");
        else if (isTencent) safeCall(tencentRef, "mute");
      },
      unmute: () => {
        if (isNano) safeCall(nanoRef, "unmute");
        else if (isTencent) safeCall(tencentRef, "unmute");
      },
      volume: (val) => {
        if (isNano) safeCall(nanoRef, "volume", val);
        else if (isTencent) safeCall(tencentRef, "volume", val);
      }
    };
  });

  return (
    <StreamPlayerWrap>
      {isNano && (
        <NanoPlayer
          ref={nanoRef}
          stream={stream}
          altStream={altStream}
          NANO_PLAYER_URL={NANO_PLAYER_URL}
        />
      )}
       {isTencent && (
        <TencentPlayer
          ref={tencentRef}
          stream={stream}
          altStream={altStream}
          TENCENT_PLAYER_URL={TENCENT_PLAYER_URL}
        />
      )}
    </StreamPlayerWrap>
  );
});

export default StreamPlayer;